import { AccountInfo } from '@azure/msal-browser';

import { IdTokenClaims } from '../models';

/**
 * Gets title from account info.
 * Tries to get those from either `idTokenClaims` or `name` or `username`.
 * @param account Account info to get titlle from.
 */
export const getTitleFromAccount = (account: AccountInfo): string => {
  const { idTokenClaims } = account;
  if (idTokenClaims) {
    const { given_name, family_name } = idTokenClaims as IdTokenClaims;
    if (given_name || family_name) {
      return `${given_name || ''} ${family_name || ''}`;
    }
  }

  const { name, username } = account;
  if (name || username) {
    return name || username;
  }

  return '';
};
